import { Injectable, Injector } from '@angular/core';
import { FatherService } from './father.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import {BugReportInterface} from "../interfaces/bug-report.interface";
import {HttpClient} from "@angular/common/http";
import {LocalstorageService} from "./localstorage.service";

@Injectable({
  providedIn: 'root'
})
export class BugReportService extends FatherService {

  /**
   * Emits the list of files (base64 strings) selected in the FileUploadComponent.
   * BugReportFormComponent подписывается на него, чтобы получить изображения при отправке отчёта.
   */
  public fileForUpload: Subject<string[]> = new Subject<string[]>();

  constructor(
    httpClient: HttpClient,
    localstorageService: LocalstorageService
  ) {
    super(httpClient, localstorageService);
  }

  saveReport(data: Partial<BugReportInterface>): Observable<any> {
    return this.post('/api-license/bug-report', data);

  }

  getReports(): Observable<any> {
    return this.get('/api-license/bug-report').pipe(map(response => response));
  }

  updateBugReport(item: BugReportInterface) {
    return this.patch(`/api-license/bug-report/${item.id}`, item);
  }
}
